<div class="slider-container">
  <label class="slider-label">{{ label }}</label>

  <div class="slider-inputs input-group">
    <mat-form-field appearance="outline" class="slider-field">
      <input
        matInput
        type="number"
        [(ngModel)]="rangeStart"
        [min]="min"
        [max]="max"
        [step]="step"
        readonly
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="slider-field">
      <input
        matInput
        type="number"
        [(ngModel)]="rangeEnd"
        [min]="min"
        [max]="max"
        [step]="step"
        (input)="validateAndEmit()" 
      />
      <mat-error *ngIf="errorMsg">{{ errorMsg }}</mat-error>
    </mat-form-field>
    
  </div>

  <mat-slider
    [min]="min"
    [max]="max"
    [step]="step"
    (change)="onRangeChange()"
  >
    <input matSliderThumb [(ngModel)]="rangeEnd" />
  </mat-slider>
</div>
